module.exports = __webpack_public_path__ + "img/flow.ar.d90a792f.svg";